<template lang='pug'>
  auth-layout
    #sign-in.view
      bf-notice(:message='message' @close='message = ""')
      transition
        auth-body(v-show='show')
          form.sign-up-form(@submit.prevent='sign_in')
            fieldset
              bf-input
                template(slot='icon')
                  img(src='/ui/email-icon.png')
                input( required type='email' :placeholder='$t("Email")' v-model='email' )

              bf-input
                template(slot='icon')
                  img(src='/ui/password-icon.png')
                input( required :type='type' :placeholder='$t("Password")' v-model='password' )
                template(slot='reveal')
                  img(v-if="type=='password'" src='/ui/eyeopen.svg' width="30" @click='showPassword')
                  img(v-else src='/ui/eyeclose.svg' width="30" @click='showPassword')  


              bf-flex.remember-me
                input(type='checkbox' checked)
                span {{ $t('Remember me') }}

              bf-flex.button-links
                bf-button.large.combo.solid.submit(type='submit')
                  template(slot='text') {{ $t('Sign In') }}
                .forgot-password-link
                  router-link.text-only(:to='{ name: "forgot-password" }') {{ $t('Forgot Password?') }}

          bf-divider.section.borderless
          .auth-link
            span {{ $t("Don't have an account?") }}
            router-link(:to="{ name: 'sign-up', params: {} }") {{ $t("Sign Up") }}

          bf-divider.card.borderless

          bf-social-auth( 
            @sign-up='$emit( "sign-up", $event )'
            @sign-in='$emit( "update:modals", { srvs: true, csts: true } )'
          )

          terms-policy(v-show='show' key='terms-policy')
      auth-body.back-panel(v-show='show' key='back-panel')
</template>

<script>
  import { auth, firebase, db } from '@/main'
  import AuthLayout from '@/layouts/auth'
  import AuthBody from '@/components/auth-body'
  import TermsPolicy from '@/components/terms-policy'

  import { Animatable } from '@/mixins/view'

  export default {
    name: 'view.sign-in',

    components: {
      AuthLayout,
      AuthBody,
      TermsPolicy
    },

    mixins: [ Animatable ],

    data() {
      return {
        email: '',
        password: '',
        confirm: '',
        message: '',
        type: 'password'
      }
    },

    methods: {
      sign_in() {
        auth.signInWithEmailAndPassword( this.email, this.password ).then( snap => {
          localStorage.user = JSON.stringify( snap.user )
          this.$emit( 'update:modals', { srvs: true, csts: true } )
        }).catch( e => 
          this.message = this.$t( e )
        )
      },
      
      showPassword() {
        if( this.type == 'password') {
          this.type = 'text'
        } else {
          this.type = 'password'
        }
      }
    },

    created() {

    }
  }

</script>

<style scoped lang='stylus'>
  .v-leave-to
    transform scale(.88) translateY(440px)
    transition all 480ms
    height 0
    *
      display none

  .button-links
    margin-top 26px
    align-items center
    justify-content space-between
    .forgot-password-link
      margin-left 8px
      text-align right

  .remember-me
    margin 16px
    align-items center
    input
      margin-right 8px
</style>
